var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-wrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:{'active': _vm.activeIndex == index},on:{"click":function($event){return _vm.changeTab(index)}}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }